export function loadCustomStringPrototypes() {
  String.prototype.isNullOrEmpty = function () {
    return !(typeof this === 'string' && this.length > 0);
  };
}
